module.exports = __webpack_public_path__ + "media/images/contest-label-right@2x-92ac69b7d3228de4a041ef6c4686d484.png";